import { SimplePageContentWrapper, SimplePageLayout } from '@flexinet/ui-components';
import { ReportsGrid } from '../components/ReportsGrid';
import { IndexPageHeader } from '../components/IndexPageHeader';
import { IndexPageNavigation } from '../navigation/IndexPageNavigation';

export const IndexPage = () => {
  return (
    <SimplePageLayout
      pageHeader={<IndexPageHeader />}
      pageNavigation={<IndexPageNavigation />}
    >
      <SimplePageContentWrapper>
        <ReportsGrid />
      </SimplePageContentWrapper>
    </SimplePageLayout>
  );
};